import { trackPageView } from "@snowplow/browser-tracker";
export default function (contextsHandler) {
    trackPageView({
        context: [
            ...contextsHandler.getGlobalContexts(), contextsHandler.getWebSearchContext()
        ],
    });
}
